export default "__VITE_ASSET__CNDlnE2O__"